import { render, staticRenderFns } from "./BlogHero.vue?vue&type=template&id=691a12a0"
import script from "./BlogHero.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogHero.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports